import { Timeline } from '@any-ui-react/core';
import classNames from 'classnames';

export interface CustomerActivityTimelineNodeProps {
  children?: React.ReactNode;
  hideBullet?: boolean;
}

export const CustomerActivityTimelineNode = ({
  children,
  hideBullet,
}: CustomerActivityTimelineNodeProps) => {
  return (
    <Timeline.Item
      classNames={{
        itemBody: 'mb-4 pl-[34px]!',
        itemBullet: classNames('top-[5px] left-[13px]!', { hidden: hideBullet }),
        item: 'mt-0 pl-0! before:left-4!',
      }}
      bullet={
        <div className="border-gray-2 h-2 w-2 shrink-0 rounded-full border-[0.188rem] bg-white" />
      }
    >
      {children}
    </Timeline.Item>
  );
};
